<template>
  <fragment>
    <transition v-if="loaded" name="fade" :duration="150" mode="out-in">
      <router-view/>
    </transition>
    <t-loading :visible="loading" :initial="true"/>
    <dialog-cadastro v-if="loaded"/>
    <dialog-pagamento v-if="loaded"/>
    <dialog-first-access v-if="loaded" />
    <dialog-access-by-code v-if="loaded" />
    <nav-drawer v-if="loaded"/>
  </fragment>
</template>

<script>
import { mapActions } from 'vuex'
import { TLoading } from '@/components/base'
import DialogCadastro from '@/components/common/DialogCadastro'
import DialogPagamento from '@/components/common/DialogPagamento'
import DialogFirstAccess from '@/components/common/DialogFirstAccess'
import DialogAccessByCode from '@/components/common/DialogAcessByCode'
import NavDrawer from '@/components/common/NavDrawer'

export default {
  name: 'app',
  components: { TLoading, DialogCadastro, DialogPagamento, DialogFirstAccess, DialogAccessByCode, NavDrawer },
  data () {
    return {
      loaded: false,
      loading: false
    }
  },
  methods: {
    ...mapActions(['getConfig'])
  },
  mounted () {
    const t = setTimeout(() => {
      this.loading = true
    }, 250)
    this.getConfig().then(config => {
      let colors = Object.keys(config.colors).filter(key => key !== 'on').map(key => ({ key, value: config.colors[key] }))
      let onColors = Object.keys(config.colors.on).map(key => ({ key: `on-${key}`, value: config.colors.on[key] }))
      ;[...colors, ...onColors].forEach(({ key, value }) => this.$cssVariables.set(key, value))
      if (config.images.favicon) {
        document.getElementById('favicon').href = config.images.favicon
      }
      if (config.strings['page-title']) {
        document.title = config.strings['page-title']
      }
      this.loaded = true
    }).finally(() => {
      clearTimeout(t)
      this.loading = false
    })
  }
}
</script>

<style lang="scss" src="@/scss/global.scss"/>
